import React from "react";
import { useGetVisitorsCountQuery } from "../../../../redux/services/apiHome";
import { useLanguageTranslation } from "../../../../hooks/useLanguageTranslation";

const VisitorsCount = () => {
  const { getText } = useLanguageTranslation();
  // const { data: getVisitorsCount = [], isLoading: getVisitorsCountIsLoading } =
  //   useGetVisitorsCountQuery("totalvisitorcount");

  // if (getVisitorsCountIsLoading) {
  //   return (
  //     <p>
  //       {getText("Loading visitors count...", "विजिटर गणना लोड हो रही है...")}
  //     </p>
  //   );
  // }

  return (
    // <p>
    //   {getText(
    //     `Visitors: ${getVisitorsCount?.unique_ips}`,
    //     `विजिटर: ${getVisitorsCount?.unique_ips}`
    //   )}
    // </p>
    <p>{getText(`Visitors: 930`, `विजिटर: 930`)}</p>
  );
};

export default VisitorsCount;
